<script lang="ts">
  import { mdiPlus, mdiSwapHorizontal, mdiMinusCircleOutline } from "@mdi/js"
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import InboxActionToggleCell from "../../../../../../_shared/_modules/inbox-action-toggle-cell"
  import type { VerifyCustomerDraft, VerifyCustomerRow } from "../../contract"

  let props: InboxWorkflowCellProps<VerifyCustomerRow, VerifyCustomerDraft> = $props()

  const value = $derived(String(props.binding.value ?? ""))
  const options = $derived(
    props.binding.options.map((option) => ({
      value: option.value,
      label: option.label ?? option.name ?? option.value,
      icon:
        option.value === "create_new"
          ? mdiPlus
          : option.value === "skip"
            ? mdiMinusCircleOutline
            : mdiSwapHorizontal,
      tone: option.value === "skip" ? ("neutral" as const) : ("primary" as const),
      disabled: option.disabled,
      tooltip: option.tooltip,
      tooltipContent: option.tooltipContent,
      dataTestid: option.dataTestid,
    })),
  )
</script>

<InboxActionToggleCell
  {value}
  {options}
  disabled={props.binding.disabled}
  ariaLabel={`Als was ${props.row.customerLabel} speichern?`}
  wrap={true}
  allowEmptySelection={true}
  onChange={(next) => props.binding.setValue(next)}
/>
